import Icon from '../components/Icon';

const Shield = Icon(
  'shield',
  <>
    <path
      fillRule="evenodd"
      d="M12 1.88a.87.87 0 0 0-.46.152c-.3.182-1.685.994-3.464 1.638a32 32 0 0 1-3.66 1.08c-.377.083-.691.154-.977.44A1.5 1.5 0 0 0 3 6.25v4.012c0 3.875 1.797 6.685 3.738 8.561 1.923 1.86 4.024 2.842 4.792 3.097.305.104.636.104.94 0 .767-.255 2.868-1.238 4.792-3.097C19.203 16.945 21 14.136 21 10.26V6.25a1.5 1.5 0 0 0-1.414-1.498 19 19 0 0 1-3.547-1.069 63 63 0 0 1-3.615-1.68A.94.94 0 0 0 12 1.88M4.5 6.25v4.012c0 3.363 1.546 5.806 3.28 7.483 1.745 1.687 3.644 2.559 4.22 2.75.578-.193 2.476-1.065 4.22-2.75 1.734-1.678 3.28-4.121 3.28-7.485V6.25c-.452 0-.956-.19-1.387-.304-2.122-.556-4.123-1.49-6.082-2.463-1.94 1.115-4.058 1.889-6.214 2.466-.437.117-.873.218-1.317.3"
      clipRule="evenodd"
    />
  </>
);

export default Shield;
